import React from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Box,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

export function confirm(
  confirmation,
  proceedLabel = "OK",
  cancelLabel = "cancel",
  options = {}
) {
  return new Promise((resolve) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <Dialog
            open={true}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
              style: {
                backgroundColor: "#ffc800", // A yellow similar to the original
                color: "black",
              },
            }}
          >
            <DialogTitle
              id="alert-dialog-title"
              sx={{ textAlign: "center", pt: 2, pb: 0 }}
            >
              <FontAwesomeIcon icon={faExclamationTriangle} size="2x" />
            </DialogTitle>
            <DialogContent>
              <DialogContentText
                component="div"
                id="alert-dialog-description"
                sx={{ color: "black", textAlign: "center" }}
              >
                <Typography variant="h6">{confirmation}</Typography>
              </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => {
                  resolve(false);
                  onClose();
                }}
              >
                {cancelLabel}
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  resolve(true);
                  onClose();
                }}
                autoFocus
              >
                {proceedLabel}
              </Button>
            </DialogActions>
          </Dialog>
        );
      },
      ...options,
    });
  });
}
